import { useState } from 'react';
import { brokerRecommendation, type Broker } from '@/mocks/brokers';

type BrokerButtonsProps = {
  broker: Broker;
  variant?: 'card' | 'detail';
};

export default function BrokerButtons({ broker, variant = 'card' }: BrokerButtonsProps) {
  const [showPending, setShowPending] = useState(false);
  const isCard = variant === 'card';
  const hasLink = broker.accountUrl.trim().length > 0;

  const base = isCard ? 'text-xs px-3 py-2.5' : 'text-sm px-5 py-3';

  const solidClass = `inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 ${base} font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950`;

  return (
    <div className="w-full">
      <div className={isCard ? 'grid grid-cols-2 gap-2' : 'flex flex-col gap-2 sm:flex-row'}>
        <a
          href={`#${broker.anchor}`}
          className={`inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 ${base} font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700`}
        >
          {brokerRecommendation.viewDetail}
          <i className="ri-arrow-down-line text-sm" />
        </a>

        {hasLink ? (
          <a
            href={broker.accountUrl}
            target="_blank"
            rel="noopener noreferrer sponsored"
            className={solidClass}
          >
            {brokerRecommendation.openAccount}
            <i className="ri-external-link-line text-sm" />
          </a>
        ) : (
          <button
            type="button"
            onClick={() => setShowPending((current) => !current)}
            aria-expanded={showPending}
            className={solidClass}
          >
            {brokerRecommendation.openAccount}
            <i className="ri-external-link-line text-sm" />
          </button>
        )}
      </div>

      {!hasLink && showPending && (
        <div className="mt-2.5 flex items-start gap-2 rounded-lg border border-background-300 bg-background-100/70 px-3 py-2.5">
          <i className="ri-information-line mt-0.5 text-sm text-accent-700" />
          <p className="text-[11px] leading-relaxed text-foreground-700">
            <span className="font-medium text-foreground-900">{brokerRecommendation.linkPending} — </span>
            {brokerRecommendation.linkPendingNote}
          </p>
        </div>
      )}
    </div>
  );
}